import React from 'react'
import PropTypes from 'prop-types'
import { BeListApiContext } from '../contexts/BeListApiContext'
import { withApi, extractData } from './ApiProvider'
import { encodeParams } from '../helpers/encodeParams.js'

export const withBeListApi = ComponentToWrap => {
  const WrappedComponent = (props) => {
    return (
      <BeListApiContext.Consumer>
        {value => (
          <ComponentToWrap {...props} beListApi={value} />
        )}
      </BeListApiContext.Consumer>
    )
  }

  WrappedComponent.displayName = `withBeListApi(${ComponentToWrap.displayName || ComponentToWrap.name})`
  return WrappedComponent
}

const BeListApiProviderComponent = (props) => {
  const { children, apiWrapper } = props

  const endpointsProvider = (baseURL) => {
    return {
      //  Tags
      getAllTags: (idList, onlyEnabled, onlyUsed, pageSize, pageNumber, orderBy, orderDescending) => (`${baseURL}/api/tags?${encodeParams({ idList, onlyEnabled, onlyUsed, pageSize, pageNumber, orderBy, orderDescending })}`),
      //  Lists
      getList: (idList) => (`${baseURL}/api/list/${encodeURIComponent(idList)}`),

      getEntitiesUsingFilter: (idFilter) => (`${baseURL}/api/filter/${encodeURIComponent(idFilter)}/entities`),

      getListOfNlList: (force, pageSize, pageNumber, orderBy, orderDescending) => (`${baseURL}/api/lists?${encodeParams({ force, pageSize, pageNumber, orderBy, orderDescending })}`)

    }
  }

  const endpoints = endpointsProvider(process.env.BELIST_URL)

  const getAllTags = (idList, onlyEnabled = false, onlyUsed = false, pageSize = 0, pageNumber = 1, orderBy = 'Id', orderDescending = true) => {
    const url = endpoints.getAllTags(idList, onlyEnabled, onlyUsed, pageSize, pageNumber, orderBy, orderDescending)

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  const getEntitiesUsingFilter = (idFilter) => {
    const url = endpoints.getEntitiesUsingFilter(idFilter)

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  const getList = (idList) => {
    const url = endpoints.getList(idList)

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  const getListOfNlList = (force = false, pageSize = 0, pageNumber = 0, orderBy = '', orderDescending = false) => {
    const url = endpoints.getListOfNlList(force, pageSize, pageNumber, orderBy, orderDescending)

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  const beListApi = {
    getAllTags,
    getList,
    getEntitiesUsingFilter,
    getListOfNlList
  }

  return (
    <BeListApiContext.Provider value={beListApi}>
      {children}
    </BeListApiContext.Provider>
  )
}

BeListApiProviderComponent.defaultProps = {
  children: null
}

BeListApiProviderComponent.propTypes = {
  children: PropTypes.node,
  apiWrapper: PropTypes.func.isRequired
}

export const BeListApiProvider = withApi(BeListApiProviderComponent)
